export const ExamEndpoint={
    start:'/v3/exam/section/start',
    finish:'/v3/exam/section/finish',
    answer_sheet:(examId:string)=>`/v3/exam/section/${examId}`

}